import moment from 'moment-timezone'
import React from 'react'
import { CellProps } from 'react-table'

import { useCurrentOrg } from 'civic-champs-shared/auth/hooks'
import { DEFAULT_TIME_ZONE } from 'civic-champs-shared/utils/format'

export const CheckInTimeCell = <D extends object, V = any>({ cell }: CellProps<D, V>) => {
  const org = useCurrentOrg()

  if (!cell.value) return ''

  const tz = org.timeZone || DEFAULT_TIME_ZONE
  const now = moment.tz(tz)
  const time = moment.tz(cell.value, tz)

  return time.isSame(now, 'day') ? time.format('h:mm a') : time.format('M/D/YYYY h:mm a')
}

export const LocalTimeCell = <D extends object, V = any>({ cell }: CellProps<D, V>) => {
  const org = useCurrentOrg()
  const tz = org.timeZone || DEFAULT_TIME_ZONE

  return !cell.value ? '' : moment.tz(cell.value, tz).format('h:mm a')
}
